import { Component, OnInit, Input } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import { DialogService } from 'ng2-bootstrap-modal';
import { RealPipe } from 'ng2-brpipes/src/real.pipe';
import { ConfirmComponent } from '../../../shared/confirm/confirm.component';
import { CommonService } from '../../../common/service/common.service';
import { LimitFlowProposalService } from '../../service/limit-flow-proposal/limit-flow-proposal.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-approval-committee',
	templateUrl: './approval-committee.component.html',
	styleUrls: ['./approval-committee.component.scss'],
	providers: [
		CommonService,
		RealPipe
	]
})
export class ApprovalCommitteeComponent implements OnInit {

	private haveNew = false;
	private isApprover = false;
	private levelList = [];
	private action = '';
	private valueToApprove = 0;
	private allowedToApprove = false;
	private commentary = '';
	private selectedLine;
	public permissoes: any[] = [];

	private approvedLevelID;
	private lastLevelID;

	@Input('proposalID') proposalID: string = "";
	@Input('userID') userID = '';
	@Input('LCProposto') LCProposto = 0;
	@Input('accountClientID') accountClientID;
	@Input('proposalStatus') proposalStatus;
	@Input('userPerfil') userPerfil = '';
	@Input('segmentoID') segmentoID: string = "";

	constructor(private flashMessagesService: FlashMessagesService,
		private commonService: CommonService,
		private limitFlowProposalService: LimitFlowProposalService,
		private router: Router,
		private dialogService: DialogService,
		private realPipe: RealPipe) {
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];

		this.getComite();
	}

	getComite() {
		this.limitFlowProposalService.getComite(this.proposalID).subscribe(result => {
			if (result.Success) {
				this.levelList = result.Result;
				console.log("COMITE", this.levelList);

				//Store the last level index.
				this.lastLevelID = this.levelList[this.levelList.length - 1].ID;
				console.log("this.lastLevelID", this.lastLevelID);

				//If approved index equals last level Reload Account Client;
				if (this.approvedLevelID && this.lastLevelID == this.approvedLevelID) {
					this.reloadAccountClient();
				}
			}
		}, error => {
			console.log(error);
		});
	}

	addLevel() {
		this.limitFlowProposalService.addLevel(this.proposalID).subscribe(result => {
			if (result.Success) {
				console.log("Add level", result.Result);
				this.getComite();
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	actionChanged(index) {
		this.valueToApprove = 0;
		this.selectedLine = index;
		this.isApprover = true;
	}

	onApprove() {
		let disposable = this.dialogService.addDialog(ConfirmComponent, {
			title: 'Confirmação de Aprovação',
			message: 'Confirma a aprovação de ' + this.realPipe.transform(this.valueToApprove) + "?"
		},
		{ backdropColor: 'rgba(0, 0, 0, 0.5)' })
		.subscribe((isConfirmed) => {
			//We get dialog result
			if (isConfirmed) {
				this.approve();
			}
			else {
				//Do nothing here
			}
		});
	}

	approve() {
		const tempObj = {
			ID: this.levelList[this.selectedLine].ID,
			PropostaLCID: this.proposalID,
			ValorEstipulado: this.valueToApprove,
			Comentario: this.commentary,
			StatusComiteID: this.action
		}

		this.limitFlowProposalService.saveApprove(tempObj).subscribe(result => {
			if (result.Success) {
				// To show errors when success
				const errorList = [] = result.Errors;
				if (errorList && errorList.length > 0) {
					errorList.forEach(error => {
						this.flashMessagesService.show(error, { cssClass: 'alert-warning', timeout: 6000 });
					});
				}

				// Store approved index of comittee
				this.approvedLevelID = this.levelList[this.selectedLine].ID;
				console.log("approvedLevelID", this.approvedLevelID);

				if (this.action == 'RF') {
					// Reload accountclient when reproved
					this.flashMessagesService.show("Proposta de LC reprovada", { cssClass: 'alert-success', timeout: 6000 });
					this.reloadAccountClient();
				} else {
					// Reset fields and get comittee again
					this.flashMessagesService.show("Ação de Comitê realizada com sucesso", { cssClass: 'alert-success', timeout: 6000 });
					this.isApprover = false;
					this.commentary = '';
					this.action = '';
					this.getComite();
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	checkApprover(arrayAprovadores: string[]) {
		return arrayAprovadores.findIndex(c => c.includes(this.userPerfil)) != -1;
	}

	checkCompliance() {
		return this.valueToApprove > this.LCProposto;
	}

	reloadAccountClient() {
		this.router.navigateByUrl('/').then(
			() => {
				this.router.navigateByUrl('/conta-cliente/detalhe/' + this.accountClientID);
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/approval-committee/approval-committee.component.ts